import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect } from 'react';
import { MessageBoxesContainer } from '../../components/messageBoxes/messageBoxesContainer';
import { PrizeWinContainer } from '../../components/prizes/prizeWinContainer';
import { RebuyWindowContainer } from '../../components/rebuyWindowContainer';
import { ToastsContainer } from '../../components/toastsContainer';
import { useSceneResize } from '../../hooks/useSceneResize';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { setMobileWarningModalAsShown } from '../../redux/actions/sessionActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { DEFAULT_BACKGROUND_COLOR } from '../../styles/colors';
import { getMobileWarningMessageBoxType } from '../../utils/mobileWarningUtils';
import { LobbyHeaderBar } from './lobbyHeaderBar';
import { LobbySceneMainDisplay } from './lobbySceneMainDisplay';
const SCENE_CONTAINER_CSS = css `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: ${DEFAULT_BACKGROUND_COLOR};
`;
export const LobbyScene = () => {
    const dispatch = useAppDispatch();
    const wasMobileWarningModalShown = useAppSelector((state) => state.session.wasMobileWarningModalShown);
    useEffect(() => {
        if (wasMobileWarningModalShown) {
            // only show PWA instructions modal once per session
            return;
        }
        const mobileWarningMessageBoxType = getMobileWarningMessageBoxType();
        if (mobileWarningMessageBoxType) {
            // TODO: Record a StatsD metric of players who get the PWA warning modal, making it possible to see if some players repeatedly ignore this warning and have a worse experience as a result.
            dispatch(addMessageBox({ type: mobileWarningMessageBoxType }));
        }
        dispatch(setMobileWarningModalAsShown());
    }, [dispatch, wasMobileWarningModalShown]);
    useSceneResize();
    return (_jsxs("div", { "data-testid": 'lobby-scene', css: SCENE_CONTAINER_CSS, children: [_jsx(LobbyHeaderBar, {}), _jsx(LobbySceneMainDisplay, {}), _jsx(ToastsContainer, {}), _jsx(MessageBoxesContainer, {}), _jsx(RebuyWindowContainer, {}), _jsx(PrizeWinContainer, {})] }));
};
